















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { meta } from 'frontend/utils/decorators';

import GeneralPathCourses from 'frontend/views/landing/GeneralPathCourses.vue';
import Landing from 'frontend/views/landing/Landing.vue';
import LandingHeaderV2 from 'frontend/views/landing/LandingHeaderV2.vue';
import LandingHeroV2 from 'frontend/views/landing/LandingHeroV2.vue';
import Recognition from 'frontend/views/landing/Recognition.vue';
import LearningPaths from 'frontend/views/landing/LearningPaths.vue';
import JoinCTA from 'frontend/views/landing/JoinCTA.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import SponsorModal from 'frontend/views/index/SponsorModal.vue';

import { MobileGetter } from 'frontend/types';
import { GeneralPath } from 'frontend/types/courses';

@Component({
  components: {
    Landing,
    GeneralPathCourses,
    Recognition,
    JoinCTA,
    LandingHeaderV2,
    LandingHeroV2,
    LearningPaths,
    LandingFooter,
    SponsorModal,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('response', ['baseUrl', 'requestPath']),
    ...mapState('generalPath', ['generalPath']),
    ...mapState('sponsorModalInfo', ['show_sponsor_modal']),
  },
})
export default class MarketingLandingPage extends Vue {
  private isMobile!: MobileGetter;
  private baseUrl!: string;
  private requestPath!: string;
  private generalPath!: GeneralPath;

  @meta
  private metaInfo() {
    return {
      titleTemplate: 'Brilliant | Learn interactively',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Brilliant - Build quantitative skills in math, science, and computer science
            with hands-on, interactive lessons.`,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `Brilliant - Build quantitative skills in math, science, and computer science
            with hands-on, interactive lessons.`,
        },
        { vmid: 'og:title', property: 'og:title', content: 'Brilliant | Learn interactively' },
        {
          vmid: 'og:image',
          property: 'og:image',
          content:
            'https://brilliant.org/site_media/version-a36afe2dd2/images/' +
            'open-graph/logged-out-home-pix-v2.png',
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: `${this.baseUrl}${this.requestPath.split('?')[0]}`,
        },
        { vmid: 'twitter:site', name: 'twitter:site', content: '@brilliantorg' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      ],
    };
  }

  private get title() {
    const pathNameHTML = `<strong>${this.generalPath.name}</strong>`;
    if (this.generalPath.marketing_title) {
      return this.generalPath.marketing_title.replace(/\[PATH_NAME\]/g, pathNameHTML);
    }
    return `Start learning ${pathNameHTML} today`;
  }

  private get heroVideoUrl() {
    if (this.generalPath.hero_video_url) {
      return this.generalPath.hero_video_url;
    }
    if (this.isMobile(this.$mq)) {
      return '/site_media/version-1/images/landing/ui-demo-mobile-compressed-no-audio.mp4';
    }
    return '/site_media/version-1/images/landing/ui-demo-compressed-no-audio.mp4';
  }

  private get isMathcounts(): boolean {
    return this.generalPath.slug === 'mathcounts';
  }

  private get ctaHref(): string | undefined {
    return this.isMathcounts ? this.$router.resolve({ name: 'teacher_landing' }).href : undefined;
  }
}
